(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency || 'GBP',
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    };

    const updateHeaderCartCount = (itemCount) => {
      const cartLink = document.querySelector('.site-header__cart');
      if (!cartLink) return;

      let countEl = cartLink.querySelector('.site-header__cart-count');

      if (itemCount > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'site-header__cart-count';
          cartLink.appendChild(countEl);
        }

        countEl.textContent = itemCount;
      } else if (countEl) {
        countEl.remove();
      }
    };

    const initCartPage = (cartPage) => {
      if (!cartPage || cartPage.dataset.cartInitialized === 'true') return;

      const currency = cartPage.dataset.shopCurrency || 'GBP';
      const quantityShortTemplate = cartPage.dataset.quantityShort || 'Qty __COUNT__';
      const cartForm = cartPage.querySelector('.cart-page__form');
      let updateQueue = Promise.resolve();

      const formatQuantityLabel = (count) => quantityShortTemplate.replace('__COUNT__', count);

      const applyItemQuantityLimits = (itemEl) => {
        if (!itemEl || !window.SandyInventory) return;

        const variant = SandyInventory.getVariantFromDataset(itemEl);
        const maxQuantity = SandyInventory.getMaxLineQuantity(variant);

        SandyInventory.applyQuantityControls({
          input: itemEl.querySelector('[data-quantity-input]'),
          minusButton: itemEl.querySelector('[data-qty-minus]'),
          plusButton: itemEl.querySelector('[data-qty-plus]'),
          maxQuantity,
        });
      };

      const applyAllItemQuantityLimits = () => {
        cartPage.querySelectorAll('[data-cart-item]').forEach(applyItemQuantityLimits);
      };

      const getItemMaxQuantity = (itemEl) => {
        if (!window.SandyInventory) return null;
        return SandyInventory.getMaxLineQuantity(SandyInventory.getVariantFromDataset(itemEl));
      };

      const setCartBusy = (busy) => {
        cartPage.classList.toggle('cart-page--updating', busy);
        cartPage.querySelectorAll('[data-quantity-input], [data-qty-minus], [data-qty-plus]').forEach((control) => {
          control.disabled = busy;
        });
      };

      const updateSummaryQuantity = (summaryItem, quantity) => {
        const meta = summaryItem.querySelector('[data-summary-meta]');
        if (!meta) return;

        const qtyEl = meta.querySelector('[data-summary-qty]');
        const prefixEl = meta.querySelector('[data-summary-qty-prefix]');
        const hasOptions = prefixEl !== null;

        if (!qtyEl) return;

        if (quantity > 1) {
          meta.hidden = false;
          qtyEl.textContent = formatQuantityLabel(quantity);
          if (prefixEl) {
            prefixEl.textContent = ' • ';
          }
        } else {
          qtyEl.textContent = '';
          if (prefixEl) {
            prefixEl.textContent = '';
          }

          if (!hasOptions) {
            meta.hidden = true;
          }
        }
      };

      const updateCartUi = (cart) => {
        const activeKeys = new Set(cart.items.map((item) => item.key));

        cartPage.querySelectorAll('[data-cart-item]').forEach((itemEl) => {
          if (!activeKeys.has(itemEl.dataset.itemKey)) {
            itemEl.remove();
          }
        });

        cartPage.querySelectorAll('[data-summary-item]').forEach((itemEl) => {
          if (!activeKeys.has(itemEl.dataset.itemKey)) {
            itemEl.remove();
          }
        });

        cart.items.forEach((item, index) => {
          const line = index + 1;
          const itemEl = cartPage.querySelector(`[data-cart-item][data-item-key="${item.key}"]`);
          const summaryEl = cartPage.querySelector(`[data-summary-item][data-item-key="${item.key}"]`);
          const input = itemEl?.querySelector('[data-quantity-input]');

          if (input) {
            input.value = item.quantity;
            input.dataset.line = String(line);
          }

          itemEl?.querySelector('[data-qty-minus]')?.setAttribute('data-line', String(line));
          itemEl?.querySelector('[data-qty-plus]')?.setAttribute('data-line', String(line));

          const linePrice = itemEl?.querySelector('[data-line-price]');
          const linePriceCurrent = linePrice?.querySelector('[data-line-price-current]');
          const linePriceCompare = linePrice?.querySelector('[data-line-price-compare]');

          if (linePriceCurrent) {
            linePriceCurrent.textContent = formatMoney(item.final_line_price, currency);
          }

          if (linePriceCompare) {
            if (item.original_line_price !== item.final_line_price) {
              linePriceCompare.textContent = formatMoney(item.original_line_price, currency);
              linePriceCompare.hidden = false;
            } else {
              linePriceCompare.hidden = true;
            }
          }

          const summaryPrice = summaryEl?.querySelector('[data-summary-price]');
          if (summaryPrice) {
            summaryPrice.textContent = formatMoney(item.final_line_price, currency);
          }

          if (summaryEl) {
            updateSummaryQuantity(summaryEl, item.quantity);
          }
        });

        const headingCount = cartPage.querySelector('[data-cart-heading-count]');
        if (headingCount) {
          headingCount.textContent = `(${cart.item_count})`;
        }

        const subtotalEl = cartPage.querySelector('[data-cart-subtotal]');
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.items_subtotal_price, currency);
        }

        const totalEl = cartPage.querySelector('[data-cart-total]');
        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price, currency);
        }

        updateHeaderCartCount(cart.item_count);
        applyAllItemQuantityLimits();
      };

      const changeQuantity = (itemKey, quantity) => {
        updateQueue = updateQueue
          .then(async () => {
            setCartBusy(true);

            const changeUrl = window.Shopify?.routes?.root
              ? `${window.Shopify.routes.root}cart/change.js`
              : '/cart/change.js';

            const response = await fetch(changeUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                id: itemKey,
                quantity: Math.max(0, quantity),
              }),
            });

            if (!response.ok) {
              throw new Error('Cart update failed');
            }

            const cart = await response.json();

            if (cart.item_count === 0) {
              window.location.reload();
              return;
            }

            updateCartUi(cart);
            SandyInventory?.invalidateCart();
          })
          .catch(() => {
            window.location.reload();
          })
          .finally(() => {
            setCartBusy(false);
            applyAllItemQuantityLimits();
          });

        return updateQueue;
      };

      const getItemKey = (line) => {
        const input = cartPage.querySelector(`[data-quantity-input][data-line="${line}"]`);
        return input?.closest('[data-cart-item]')?.dataset.itemKey;
      };

      cartPage.querySelectorAll('[data-qty-minus]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const line = btn.dataset.line;
          const input = cartPage.querySelector(`[data-quantity-input][data-line="${line}"]`);
          const itemKey = getItemKey(line);
          const itemEl = input?.closest('[data-cart-item]');

          if (!input || !itemKey || !itemEl) return;

          const nextQuantity = Math.max(0, parseInt(input.value, 10) - 1);
          input.value = nextQuantity;
          applyItemQuantityLimits(itemEl);
          changeQuantity(itemKey, nextQuantity);
        });
      });

      cartPage.querySelectorAll('[data-qty-plus]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const line = btn.dataset.line;
          const input = cartPage.querySelector(`[data-quantity-input][data-line="${line}"]`);
          const itemKey = getItemKey(line);
          const itemEl = input?.closest('[data-cart-item]');

          if (!input || !itemKey || !itemEl) return;

          const currentQuantity = parseInt(input.value, 10);
          const maxQuantity = getItemMaxQuantity(itemEl);

          if (!SandyInventory?.canIncrease(currentQuantity, maxQuantity)) return;

          const nextQuantity = currentQuantity + 1;
          input.value = nextQuantity;
          applyItemQuantityLimits(itemEl);
          changeQuantity(itemKey, nextQuantity);
        });
      });

      cartPage.querySelectorAll('[data-quantity-input]').forEach((input) => {
        input.addEventListener('change', () => {
          const itemKey = input.closest('[data-cart-item]')?.dataset.itemKey;
          const itemEl = input.closest('[data-cart-item]');
          if (!itemKey || !itemEl) return;

          let nextQuantity = Math.max(0, parseInt(input.value, 10) || 0);
          const maxQuantity = getItemMaxQuantity(itemEl);

          if (maxQuantity !== null) {
            nextQuantity = Math.min(nextQuantity, maxQuantity);
          }

          input.value = nextQuantity;
          applyItemQuantityLimits(itemEl);
          changeQuantity(itemKey, nextQuantity);
        });
      });

      cartForm?.addEventListener('submit', (event) => {
        const submitter = event.submitter;

        if (!submitter || submitter.name !== 'checkout') {
          event.preventDefault();
        }
      });

      cartPage.dataset.cartInitialized = 'true';
      applyAllItemQuantityLimits();
    };

    const initAllCartPages = () => {
      document.querySelectorAll('[data-cart-page]').forEach(initCartPage);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCartPages);
    } else {
      initAllCartPages();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const cartPage = event.target.querySelector('[data-cart-page]');

      if (cartPage) {
        delete cartPage.dataset.cartInitialized;
        initCartPage(cartPage);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const getPanelHeight = (panel) => {
      const content = panel.querySelector('.faq__answer');
      return content ? content.scrollHeight : panel.scrollHeight;
    };

    const setPanelHeight = (panel, height) => {
      panel.style.height = typeof height === 'number' ? `${height}px` : height;
    };

    const initFaqAccordion = (faqSection) => {
      if (!faqSection || faqSection.dataset.faqInitialized === 'true') return;

      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      faqSection.querySelectorAll('.faq__item').forEach((item) => {
        const summary = item.querySelector('.faq__question');
        const panel = item.querySelector('.faq__answer-panel');

        if (!summary || !panel) return;

        if (item.hasAttribute('open')) {
          setPanelHeight(panel, 'auto');
        } else {
          setPanelHeight(panel, '0px');
        }

        item.classList.add('faq__item--initialized');

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (item.hasAttribute('open')) {
            if (motionQuery.matches) {
              item.removeAttribute('open');
              setPanelHeight(panel, '0px');
              return;
            }

            setPanelHeight(panel, getPanelHeight(panel));
            panel.offsetHeight;

            requestAnimationFrame(() => {
              setPanelHeight(panel, 0);
            });

            panel.addEventListener('transitionend', function onClose(event) {
              if (event.propertyName !== 'height') return;
              item.removeAttribute('open');
              panel.removeEventListener('transitionend', onClose);
            });
          } else {
            item.setAttribute('open', '');

            if (motionQuery.matches) {
              setPanelHeight(panel, 'auto');
              return;
            }

            setPanelHeight(panel, 0);
            panel.offsetHeight;

            requestAnimationFrame(() => {
              setPanelHeight(panel, getPanelHeight(panel));
            });

            panel.addEventListener('transitionend', function onOpen(event) {
              if (event.propertyName !== 'height') return;
              setPanelHeight(panel, 'auto');
              panel.removeEventListener('transitionend', onOpen);
            });
          }
        });
      });

      faqSection.dataset.faqInitialized = 'true';
    };

    const initAllFaqAccordions = () => {
      document.querySelectorAll('[data-faq-accordion]').forEach(initFaqAccordion);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFaqAccordions);
    } else {
      initAllFaqAccordions();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const faqSection = event.target.querySelector('[data-faq-accordion]');

      if (faqSection) {
        delete faqSection.dataset.faqInitialized;
        initFaqAccordion(faqSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency || 'GBP',
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    };

    const initProductPage = (page) => {
      if (!page || page.dataset.productInitialized === 'true') return;

      const productJson = page.querySelector('[data-product-json]');
      if (!productJson) return;

      const product = JSON.parse(productJson.textContent);
      const currency = page.dataset.shopCurrency || 'GBP';
      const variantIdInput = page.querySelector('[data-variant-id]');
      const optionInputs = page.querySelectorAll('[data-option-input]');
      const mainImage = page.querySelector('[data-main-image]');
      const thumbnails = page.querySelectorAll('[data-thumbnail]');
      const qtyInput = page.querySelector('[data-quantity-input]');
      const qtyMinus = page.querySelector('[data-qty-minus]');
      const qtyPlus = page.querySelector('[data-qty-plus]');
      const priceCurrent = page.querySelector('[data-price-current]');
      const priceCompare = page.querySelector('[data-price-compare]');
      const submitButton = page.querySelector('.product-page__submit');
      const buyNowButton = page.querySelector('[data-buy-now]');
      const productForm = page.querySelector('[data-product-form]');
      const tabsRoot = page.querySelector('[data-product-tabs]');

      const getSelectedOptions = () => {
        const options = [];

        product.options.forEach((_, index) => {
          const checked = page.querySelector(`[data-option-input][data-option-position="${index + 1}"]:checked`);
          options.push(checked ? checked.value : null);
        });

        return options;
      };

      const findVariant = () => {
        const selected = getSelectedOptions();

        return product.variants.find((variant) =>
          variant.options.every((option, index) => option === selected[index])
        );
      };

      const updateQuantityLimits = async () => {
        if (!qtyInput || !window.SandyInventory) return;

        const variant = findVariant();
        if (!variant) return;

        const cart = await SandyInventory.fetchCart();
        const inCart = SandyInventory.getCartQuantityForVariant(cart, variant.id);
        const maxQuantity = SandyInventory.getMaxAddQuantity(variant, inCart);

        SandyInventory.applyQuantityControls({
          input: qtyInput,
          minusButton: qtyMinus,
          plusButton: qtyPlus,
          maxQuantity,
        });
      };

      const validateQuantityForAdd = async () => {
        if (!qtyInput || !window.SandyInventory) return true;

        const variant = findVariant();
        if (!variant) return false;

        const cart = await SandyInventory.fetchCart(true);
        const inCart = SandyInventory.getCartQuantityForVariant(cart, variant.id);
        const maxQuantity = SandyInventory.getMaxAddQuantity(variant, inCart);
        const requestedQuantity = SandyInventory.parseNumber(qtyInput.value) || 1;

        if (maxQuantity !== null && requestedQuantity > maxQuantity) {
          qtyInput.value = Math.max(maxQuantity, 1);
          await updateQuantityLimits();
          return false;
        }

        return true;
      };

      const updateVariant = () => {
        const variant = findVariant();
        if (!variant) return;

        variantIdInput.value = variant.id;

        if (priceCurrent) {
          priceCurrent.textContent = formatMoney(variant.price, currency);
        }

        if (priceCompare) {
          const onSale = variant.compare_at_price > variant.price;

          if (onSale) {
            priceCompare.textContent = formatMoney(variant.compare_at_price, currency);
            priceCompare.classList.remove('product-page__price-compare--hidden');
          } else {
            priceCompare.classList.add('product-page__price-compare--hidden');
          }
        }

        if (submitButton) {
          submitButton.disabled = !variant.available;
          submitButton.textContent = variant.available
            ? page.dataset.availableLabel || submitButton.textContent
            : page.dataset.soldOutLabel || 'Sold out';
        }

        if (buyNowButton) {
          buyNowButton.disabled = !variant.available;
        }

        if (variant.featured_media) {
          const media = product.media.find((item) => item.id === variant.featured_media.id);

          if (media && mainImage) {
            mainImage.src = media.preview_image.src;
            mainImage.alt = media.alt || product.title;
          }

          thumbnails.forEach((thumb) => {
            thumb.classList.toggle(
              'product-page__thumbnail--active',
              Number(thumb.dataset.mediaId) === variant.featured_media.id
            );
          });
        }

        updateQuantityLimits();
      };

      optionInputs.forEach((input) => {
        input.addEventListener('change', updateVariant);
      });

      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const mediaId = Number(thumb.dataset.mediaId);
          const media = product.media.find((item) => item.id === mediaId);

          if (media && mainImage) {
            mainImage.src = media.preview_image.src;
            mainImage.alt = media.alt || product.title;
          }

          thumbnails.forEach((item) => item.classList.remove('product-page__thumbnail--active'));
          thumb.classList.add('product-page__thumbnail--active');
        });
      });

      qtyMinus?.addEventListener('click', async () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        await updateQuantityLimits();
      });

      qtyPlus?.addEventListener('click', async () => {
        const currentQuantity = parseInt(qtyInput.value, 10) || 1;

        if (!window.SandyInventory) {
          qtyInput.value = currentQuantity + 1;
          return;
        }

        const variant = findVariant();
        if (!variant) return;

        const cart = await SandyInventory.fetchCart();
        const inCart = SandyInventory.getCartQuantityForVariant(cart, variant.id);
        const maxQuantity = SandyInventory.getMaxAddQuantity(variant, inCart);

        if (!SandyInventory.canIncrease(currentQuantity, maxQuantity)) return;

        qtyInput.value = currentQuantity + 1;
        await updateQuantityLimits();
      });

      qtyInput?.addEventListener('change', async () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        await updateQuantityLimits();
      });

      let skipQuantityCheck = false;

      productForm?.addEventListener('submit', async (event) => {
        if (skipQuantityCheck) {
          skipQuantityCheck = false;
          SandyInventory?.invalidateCart();
          return;
        }

        event.preventDefault();

        const isValid = await validateQuantityForAdd();
        if (!isValid) return;

        skipQuantityCheck = true;
        productForm.requestSubmit();
      });

      buyNowButton?.addEventListener('click', async () => {
        if (!productForm || buyNowButton.disabled) return;

        const isValid = await validateQuantityForAdd();
        if (!isValid) return;

        buyNowButton.disabled = true;

        try {
          const addUrl = window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}cart/add.js`
            : '/cart/add.js';
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: new FormData(productForm),
          });

          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          SandyInventory?.invalidateCart();

          const checkoutUrl = window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}checkout`
            : '/checkout';
          window.location.href = checkoutUrl;
        } catch (error) {
          buyNowButton.disabled = false;
          productForm.submit();
        }
      });

      if (submitButton && page.dataset.availableLabel) {
        submitButton.textContent = page.dataset.availableLabel;
      }

      updateVariant();

      if (tabsRoot) {
        const tabs = tabsRoot.querySelectorAll('[data-tab]');
        const panels = tabsRoot.querySelectorAll('[data-tab-panel]');

        const ensureJudgeMeVisible = () => {
          const reviewsPanel = page.querySelector('#judgeme_product_reviews');
          if (!reviewsPanel) return;

          reviewsPanel
            .querySelectorAll('.jdgm-review-widget, .jdgm-widget, .jdgm-rev-widg')
            .forEach((node) => {
              node.style.setProperty('display', 'block', 'important');
              node.style.setProperty('visibility', 'visible', 'important');
              node.style.setProperty('opacity', '1', 'important');
            });
        };

        const REVIEW_MODAL_TRANSITION_MS = 280;

        const prefersReducedMotion = () =>
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const clearWriteReviewMessage = () => {
          const message = page.querySelector('[data-write-review-message]');
          if (!message) return;

          message.hidden = true;
          message.textContent = '';
          message.classList.remove(
            'product-page__reviews-write-message--success',
            'product-page__reviews-write-message--error'
          );
        };

        const showThemeWriteReviewForm = () => {
          const modal = page.querySelector('[data-write-review-modal]');
          if (!modal) return false;

          if (modal._reviewModalCloseTimer) {
            window.clearTimeout(modal._reviewModalCloseTimer);
            modal._reviewModalCloseTimer = null;
          }

          modal.hidden = false;
          modal.removeAttribute('hidden');
          document.body.classList.add('product-page__reviews-modal-open');

          if (prefersReducedMotion()) {
            modal.classList.add('product-page__reviews-modal--visible');
          } else {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                modal.classList.add('product-page__reviews-modal--visible');
              });
            });
          }

          modal.querySelector('input[name="name"], textarea, input[type="text"]')?.focus();
          return true;
        };

        const hideThemeWriteReviewForm = () => {
          const modal = page.querySelector('[data-write-review-modal]');
          if (!modal || modal.hidden) return;

          const finishClose = () => {
            modal.hidden = true;
            modal.classList.remove('product-page__reviews-modal--visible');
            document.body.classList.remove('product-page__reviews-modal-open');
            clearWriteReviewMessage();
          };

          if (prefersReducedMotion() || !modal.classList.contains('product-page__reviews-modal--visible')) {
            finishClose();
            return;
          }

          modal.classList.remove('product-page__reviews-modal--visible');

          if (modal._reviewModalCloseTimer) {
            window.clearTimeout(modal._reviewModalCloseTimer);
          }

          modal._reviewModalCloseTimer = window.setTimeout(() => {
            modal._reviewModalCloseTimer = null;
            finishClose();
          }, REVIEW_MODAL_TRANSITION_MS);
        };

        const setReviewStarRating = (rating) => {
          const starsRoot = page.querySelector('[data-review-stars]');
          const ratingInput = page.querySelector('[data-review-rating]');
          if (!starsRoot || !ratingInput) return;

          ratingInput.value = String(rating);
          starsRoot.querySelectorAll('[data-star-value]').forEach((star) => {
            const value = Number(star.dataset.starValue || 0);
            const isActive = value <= rating;
            star.classList.toggle('is-active', isActive);
            star.textContent = isActive ? '★' : '☆';
            star.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        };

        const openWriteReviewForm = (event) => {
          event?.preventDefault();
          event?.stopPropagation();
          showThemeWriteReviewForm();
        };

        const setupThemeWriteReviewForm = () => {
          const reviewsPanel = page.querySelector('#judgeme_product_reviews');
          const form = page.querySelector('[data-write-review-form-el]');
          const message = page.querySelector('[data-write-review-message]');
          if (!reviewsPanel || !form || form.dataset.sandyReviewFormBound === 'true') return;

          form.dataset.sandyReviewFormBound = 'true';

          page.querySelector('[data-review-stars]')?.addEventListener('click', (event) => {
            const star = event.target.closest('[data-star-value]');
            if (!star) return;
            setReviewStarRating(Number(star.dataset.starValue || 0));
          });

          form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const submitButton = form.querySelector('.product-page__reviews-write-submit');
            const formData = new FormData(form);
            const rating = Number(formData.get('rating') || 0);
            const name = String(formData.get('name') || '').trim();
            const email = String(formData.get('email') || '').trim();
            const title = String(formData.get('title') || '').trim();
            const body = String(formData.get('body') || '').trim();

            if (!message) return;

            message.hidden = false;
            message.classList.remove(
              'product-page__reviews-write-message--success',
              'product-page__reviews-write-message--error'
            );

            if (!rating) {
              message.textContent = page.dataset.reviewRatingRequired || 'Please select a star rating.';
              message.classList.add('product-page__reviews-write-message--error');
              return;
            }

            if (!body) {
              message.textContent = page.dataset.reviewError || 'Something went wrong. Please try again.';
              message.classList.add('product-page__reviews-write-message--error');
              return;
            }

            const submitName = name || 'Anonymous';
            const submitEmail =
              email || `anonymous+${reviewsPanel.dataset.judgemeProductId || 'review'}@reviews.local`;

            if (submitButton) submitButton.disabled = true;

            try {
              const params = new URLSearchParams();
              params.set('shop_domain', reviewsPanel.dataset.judgemeShop || '');
              params.set('url', reviewsPanel.dataset.judgemeShop || '');
              params.set('platform', 'shopify');
              params.set('id', reviewsPanel.dataset.judgemeProductId || '');
              params.set('name', submitName);
              params.set('email', submitEmail);
              params.set('rating', String(rating));
              params.set('title', title);
              params.set('body', body);

              const response = await fetch('https://api.judge.me/api/v1/reviews', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: params.toString(),
              });

              if (!response.ok) {
                throw new Error('Review submit failed');
              }

              message.textContent = page.dataset.reviewSuccess || 'Thank you! Your review was submitted.';
              message.classList.add('product-page__reviews-write-message--success');
              form.reset();
              setReviewStarRating(0);
            } catch (error) {
              message.textContent = page.dataset.reviewError || 'Something went wrong. Please try again.';
              message.classList.add('product-page__reviews-write-message--error');
            } finally {
              if (submitButton) submitButton.disabled = false;
            }
          });
        };

        const formatReviewDate = (timestamp) => {
          if (!timestamp || timestamp.dataset.formatted === 'true') return;

          const raw = timestamp.dataset.content || timestamp.getAttribute('data-content') || timestamp.textContent.trim();
          if (!raw) return;

          const date = new Date(raw);
          if (Number.isNaN(date.getTime())) return;

          const diffMs = Date.now() - date.getTime();
          const diffMinutes = Math.floor(diffMs / 60000);
          const diffHours = Math.floor(diffMinutes / 60);
          const diffDays = Math.floor(diffHours / 24);
          const diffWeeks = Math.floor(diffDays / 7);
          const diffMonths = Math.floor(diffDays / 30);
          const diffYears = Math.floor(diffDays / 365);
          const locale = document.documentElement.lang || 'en';

          try {
            const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

            if (diffDays < 1) {
              if (diffHours < 1) {
                timestamp.textContent = diffMinutes < 1 ? 'just now' : rtf.format(-diffMinutes, 'minute');
              } else {
                timestamp.textContent = rtf.format(-diffHours, 'hour');
              }
            } else if (diffDays < 7) {
              timestamp.textContent = rtf.format(-diffDays, 'day');
            } else if (diffWeeks < 5) {
              timestamp.textContent = rtf.format(-diffWeeks, 'week');
            } else if (diffMonths < 12) {
              timestamp.textContent = rtf.format(-diffMonths, 'month');
            } else {
              timestamp.textContent = rtf.format(-diffYears, 'year');
            }
          } catch (error) {
            timestamp.textContent = diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
          }

          timestamp.classList.remove('jdgm-spinner');
          timestamp.dataset.formatted = 'true';
        };

        const getReviewScore = (rating, review) => {
          const sources = [rating, review].filter(Boolean);

          for (const source of sources) {
            const score = Number(source.dataset.score || source.getAttribute('data-score') || 0);
            if (score) return score;
          }

          if (rating) {
            const ariaLabel = rating.getAttribute('aria-label') || '';
            const ariaMatch = ariaLabel.match(/(\d(?:\.\d+)?)/);
            if (ariaMatch) return Number(ariaMatch[1]);

            const onStars = rating.querySelectorAll('.jdgm-star.jdgm--on').length;
            if (onStars) return onStars;
          }

          const scoredNode = review?.querySelector('[data-score]');
          if (scoredNode) {
            const nestedScore = Number(scoredNode.getAttribute('data-score') || 0);
            if (nestedScore) return nestedScore;
          }

          return 0;
        };

        const renderReviewStars = (review, rating) => {
          if (!review) return;

          const score = getReviewScore(rating, review);
          if (!score) return;

          const head = review.querySelector('.product-page__rev-head');
          const starsParent = head || review;
          let starsRow = starsParent.querySelector('.product-page__rev-stars');

          if (!starsRow) {
            starsRow = document.createElement('div');
            starsRow.className = 'product-page__rev-stars';
            starsParent.insertBefore(starsRow, starsParent.firstChild);
          }

          if (starsRow.dataset.score === String(score)) return;

          starsRow.innerHTML = '';
          const roundedScore = Math.round(score);

          for (let index = 1; index <= 5; index += 1) {
            const star = document.createElement('span');
            star.className = 'product-page__rev-star';
            star.textContent = index <= roundedScore ? '★' : '☆';
            starsRow.appendChild(star);
          }

          starsRow.dataset.score = String(score);

          if (rating) {
            rating.classList.add('jdgm-rev__rating--hidden');
            rating.setAttribute('aria-hidden', 'true');
          }
        };

        const hasReplyContent = (reply) => {
          if (!reply) return false;

          const body = reply.querySelector(
            '.jdgm-rev__reply-body, .jdgm-rev__reply-content, .jdgm-shop-reply__body'
          );

          const text = (body?.textContent || reply.textContent || '').replace(/\s+/g, ' ').trim();
          return text.length > 0;
        };

        const layoutReviewReply = (review) => {
          const reply = review.querySelector(
            '.jdgm-rev__reply, .jdgm-shop-reply, .jdgm-rev__buyer-reply-wrapper'
          );
          const replyWrap = review.querySelector('.product-page__rev-reply');

          if (!hasReplyContent(reply)) {
            replyWrap?.remove();
            return;
          }

          let wrap = replyWrap;
          if (!wrap) {
            wrap = document.createElement('div');
            wrap.className = 'product-page__rev-reply';
            review.appendChild(wrap);
          }

          if (reply.parentNode !== wrap) {
            wrap.appendChild(reply);
          }

          wrap
            .querySelectorAll('.jdgm-rev__reply-author, .jdgm-shop-reply__author')
            .forEach((authorNode) => {
              authorNode.textContent = authorNode.textContent.replace(/^\s*>>\s*/, '').trim();
            });
        };

        const layoutJudgeMeReviews = () => {
          const reviewsPanel = page.querySelector('#judgeme_product_reviews');
          if (!reviewsPanel) return;

          reviewsPanel.querySelectorAll('.jdgm-rev').forEach((review) => {
            const author = review.querySelector('.jdgm-rev__author');
            const timestamp = review.querySelector('.jdgm-rev__timestamp');
            const rating = review.querySelector('.jdgm-rev__rating');
            const body = review.querySelector('.jdgm-rev__body');
            const pics = review.querySelector('.jdgm-rev__pics');

            formatReviewDate(timestamp);

            if (review.dataset.layoutVersion !== '2') {
              review.querySelector('.product-page__rev-meta')?.remove();
              review.querySelector('.product-page__rev-content')?.remove();
              review.querySelector('.product-page__rev-headline')?.remove();

              let main = review.querySelector('.product-page__rev-main');
              if (!main) {
                main = document.createElement('div');
                main.className = 'product-page__rev-main';
                review.insertBefore(main, review.firstChild);
              } else {
                main.innerHTML = '';
              }

              let head = document.createElement('div');
              head.className = 'product-page__rev-head';
              main.appendChild(head);

              if (timestamp) {
                head.appendChild(timestamp);
              }

              if (author) {
                main.appendChild(author);
              }

              if (body) {
                main.appendChild(body);
              }

              if (pics) {
                main.appendChild(pics);
              }

              review.classList.add('product-page__rev-item');
              review.dataset.layoutVersion = '2';
              delete review.dataset.layoutReady;
            }

            layoutReviewReply(review);
            renderReviewStars(review, rating);
          });
        };

        let reviewsRefreshLocked = false;

        const renderSummaryStars = (starsRoot, rating) => {
          if (!starsRoot) return;

          const score = Number(rating);
          if (!score) {
            starsRoot.innerHTML = '';
            for (let index = 1; index <= 5; index += 1) {
              const star = document.createElement('span');
              star.className = 'product-page__reviews-summary-star product-page__reviews-summary-star--empty';
              star.textContent = '★';
              starsRoot.appendChild(star);
            }
            return;
          }

          const fullStars = Math.floor(score);
          const decimal = score - fullStars;
          let hasHalfStar = false;
          let roundedFullStars = fullStars;

          if (decimal >= 0.25) {
            if (decimal < 0.75) {
              hasHalfStar = true;
            } else {
              roundedFullStars += 1;
            }
          }

          const halfAt = roundedFullStars + 1;
          starsRoot.innerHTML = '';

          for (let index = 1; index <= 5; index += 1) {
            const star = document.createElement('span');
            star.textContent = '★';

            if (index <= roundedFullStars) {
              star.className = 'product-page__reviews-summary-star product-page__reviews-summary-star--full';
            } else if (hasHalfStar && index === halfAt) {
              star.className = 'product-page__reviews-summary-star product-page__reviews-summary-star--half';
            } else {
              star.className = 'product-page__reviews-summary-star product-page__reviews-summary-star--empty';
            }

            starsRoot.appendChild(star);
          }
        };

        const updateReviewsSummary = () => {
          const reviewsPanel = page.querySelector('#judgeme_product_reviews');
          if (!reviewsPanel) return;

          const numberNode = reviewsPanel.querySelector('[data-reviews-summary-number]');
          const starsRoot = reviewsPanel.querySelector('[data-reviews-summary-stars]');
          const widget = reviewsPanel.querySelector('.jdgm-rev-widg');
          const currentRating = Number(numberNode?.dataset.rating || 0);

          let nextRating = currentRating;

          if (widget) {
            const widgetRating = Number(
              widget.dataset.averageRating || widget.getAttribute('data-average-rating') || 0
            );
            if (widgetRating > nextRating) {
              nextRating = widgetRating;
            }
          }

          if (!nextRating) {
            const reviewScores = Array.from(reviewsPanel.querySelectorAll('.jdgm-rev')).map((review) => {
              const rating = review.querySelector('.jdgm-rev__rating');
              return getReviewScore(rating, review);
            }).filter(Boolean);

            if (reviewScores.length) {
              const computedAverage =
                reviewScores.reduce((total, score) => total + score, 0) / reviewScores.length;
              if (computedAverage > nextRating) {
                nextRating = computedAverage;
              }
            }
          }

          if (!nextRating || nextRating <= currentRating) return;

          if (numberNode) {
            numberNode.textContent = nextRating.toFixed(1);
            numberNode.dataset.rating = String(nextRating);
          }

          renderSummaryStars(starsRoot, nextRating);
        };

        const refreshReviewsTab = () => {
          if (reviewsRefreshLocked) return;

          reviewsRefreshLocked = true;

          try {
            ensureJudgeMeVisible();
            layoutJudgeMeReviews();
            updateReviewsSummary();
          } finally {
            reviewsRefreshLocked = false;
          }
        };

        setupThemeWriteReviewForm();

        page.addEventListener('click', (event) => {
          if (event.target.closest('[data-write-review-trigger]')) {
            openWriteReviewForm(event);
            return;
          }

          if (event.target.closest('[data-write-review-modal-close]')) {
            event.preventDefault();
            hideThemeWriteReviewForm();
          }
        });

        page.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;

          const modal = page.querySelector('[data-write-review-modal]');
          if (modal && !modal.hidden) {
            hideThemeWriteReviewForm();
          }
        });

        page.querySelector('#judgeme_product_reviews')?.addEventListener('click', (event) => {
          const writeLink = event.target.closest('.jdgm-write-rev-link, .jdgm-write-review-link');
          if (writeLink) {
            openWriteReviewForm(event);
            return;
          }

          const cancelLink = event.target.closest('.jdgm-cancel-rev-link');
          if (!cancelLink) return;

          const formWrapper = page.querySelector('#judgeme_product_reviews .jdgm-form-wrapper');
          if (!formWrapper) return;

          formWrapper.hidden = true;
          formWrapper.classList.add('jdgm-form-wrapper--hidden');
        });

        document.addEventListener('jdgm.doneSetup', refreshReviewsTab);

        setTimeout(refreshReviewsTab, 0);
        setTimeout(refreshReviewsTab, 500);
        setTimeout(refreshReviewsTab, 1500);
        setTimeout(refreshReviewsTab, 3000);

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const target = tab.dataset.tab;

            tabs.forEach((item) => {
              const isActive = item.dataset.tab === target;
              item.classList.toggle('product-page__tab--active', isActive);
              item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            panels.forEach((panel) => {
              const isActive = panel.dataset.tabPanel === target;
              panel.classList.toggle('product-page__tab-panel--active', isActive);
              panel.hidden = !isActive;
            });

            if (target == 'reviews') {
              setTimeout(refreshReviewsTab, 0);
              setTimeout(refreshReviewsTab, 300);
              setTimeout(refreshReviewsTab, 1200);
              setTimeout(refreshReviewsTab, 2500);
            }
          });
        });

        const openReviewsTab = () => {
          const reviewsTab = tabsRoot.querySelector('[data-tab="reviews"]');
          if (reviewsTab) reviewsTab.click();
        };

        const getStickyHeaderOffset = () => {
          const headerCandidates = [
            document.querySelector('#shopify-section-header-group'),
            document.querySelector('.shopify-section-group-header-group'),
            document.querySelector('.header-wrapper'),
            document.querySelector('header[role="banner"]'),
          ].filter(Boolean);

          for (const header of headerCandidates) {
            const styles = window.getComputedStyle(header);
            const isStickyLike = styles.position === 'sticky' || styles.position === 'fixed';
            if (!isStickyLike) continue;
            if (header.offsetHeight <= 0) continue;
            return header.offsetHeight;
          }

          return 0;
        };

        const scrollToReviewsPanel = () => {
          const reviewsPanel = page.querySelector('#judgeme_product_reviews');
          if (!reviewsPanel) return;

          const headerOffset = getStickyHeaderOffset();
          const extraOffset = 12;
          const panelTop = reviewsPanel.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: Math.max(0, panelTop - headerOffset - extraOffset),
            behavior: 'smooth',
          });
        };

        page.querySelectorAll('[data-open-reviews-tab]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            openReviewsTab();
            setTimeout(refreshReviewsTab, 0);
            setTimeout(refreshReviewsTab, 300);
            setTimeout(refreshReviewsTab, 1200);
            setTimeout(scrollToReviewsPanel, 30);
          });
        });
      }

      page.dataset.productInitialized = 'true';
    };

    const initAllProductPages = () => {
      document.querySelectorAll('[data-product-page]').forEach(initProductPage);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllProductPages);
    } else {
      initAllProductPages();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const page = event.target.querySelector('[data-product-page]');

      if (page) {
        delete page.dataset.productInitialized;
        initProductPage(page);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
